import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

interface ImageUploadContainerProps {
  readonly title?: string;
  readonly dashed?: boolean;
  readonly children?: ReactNode;
  readonly className?: string;
  readonly style?: React.CSSProperties;
}

function ImageUploadContainer({ title, dashed, children, className, style }: ImageUploadContainerProps) {
  return (
    <div
      title={title}
      className={twMerge(
        'group relative flex min-h-[90px] min-w-[90px] items-center justify-center overflow-hidden rounded border border-neutral-300 bg-white',
        dashed ? 'border-dashed' : 'border-solid',
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
}

export { ImageUploadContainer };
